import { render, staticRenderFns } from "./form7.vue?vue&type=template&id=76164790&scoped=true&"
import script from "./form7.vue?vue&type=script&lang=js&"
export * from "./form7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76164790",
  null
  
)

export default component.exports